import { createStyles } from './style-object.es.js';

const camelLetterToPipeLetter = (letter) => `-${letter.toLowerCase()}`;
const camelToPipeCase = (str) => str.replace(/[A-Z]/g, camelLetterToPipeLetter);
function createStyleString(target = {}) {
    const styles = createStyles(target);
    let style = "";
    for (const key in styles) {
        style += key.startsWith("--") ? key : camelToPipeCase(key);
        style += `: ${styles[key]}; `;
    }
    return style;
}

export { createStyleString };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/animate/utils/style-string.es.js
// module id = hNXB
// module chunks = 0